<template>
  <div v-if="comment" class="bg-danger/10 border border-danger/20 max-w-[690px] p-3 mx-auto rounded-md text-dark my-5">
    <p class="text-base font-bold mb-0.5 flex items-center">
      <svg width="16" height="16" class="flex-shrink-0 fill-transparent text-danger mr-0.5">
        <use :xlink:href="`#request-in-circle`"></use>
      </svg>
      Revision Requested
    </p>
    <p class="mb-0 leading-5">
      {{ comment }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'RevisionRequested',
  props: {
    comment: {
      type: null,
      default: null,
    },
  },
}
</script>
